import { render, staticRenderFns } from "./AddShiftPage.vue?vue&type=template&id=04f2be34&"
import script from "./AddShiftPage.vue?vue&type=script&lang=js&"
export * from "./AddShiftPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports